import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';
import { useLanguage } from '../../../contexts/LanguageContext';
import { localizedPath } from '../../../utils/localizedPath';

const Logo = ({
  className,
  ...props
}) => {

  const { lang } = useLanguage();

  const classes = classNames(
    'brand',
    className
  );

  // The logo is not the page heading: the only <h1> on a page is the page title.
  return (
    <div
      {...props}
      className={classes}
    >
      <div className="m-0">
        <Link to={localizedPath('home', lang)} aria-label={lang === 'es' ? 'E-comienza, ir al inicio' : 'E-comienza, go to home'}>
          <Image
            src={require('./../../../assets/images/ecomienza-white-logo.png')}
            alt={lang === 'es' ? 'Logotipo de E-comienza' : 'E-comienza logo'}
            width={256}
            height={256} />
        </Link>
      </div>
    </div>
  );
}

export default Logo;
